import { Box, ClickAwayListener, Grow, IconButton, Paper, Popper, Tooltip } from '@mui/material'
import { SvgIcons } from '@utils/icons'
import React, { memo } from 'react'
import { CSVLink } from 'react-csv'
import Button from '../Button/Button'
import Icon from '../Icon'

// eslint-disable-next-line react/display-name
const TableMenuButton = memo(({ tableData = [], dataToExport, tableColumns }) => {
	const [anchorEl, setAnchorEl] = React.useState(null)
	const open = Boolean(anchorEl)
	const [exportData, setExportData] = React.useState([])
	const handleExportTableData = () => {
		const finalData = tableData.map((each) => {
			const formattedObj = {}
			tableColumns.map((col) => {
				const isActionsColumn = col.id.toLowerCase() === 'raw_data' || col.id.toLowerCase() === 'actions' || col.id === 'ticketData'
				if (!isActionsColumn) {
					const colData =
						typeof col.exportAs === 'function' ? col.exportAs(each.original) : Object.byString(each.original, col.id)
					// console.log("TABLECOLUMNS", colData)
					if (colData || (colData !== undefined && colData != null)) {
						formattedObj[col.header] =
							typeof colData === 'object' || Array.isArray(colData)
								? colData[col.header.toLowerCase()]
									? colData[col.header.toLowerCase()]
									: colData.length > 0
									? colData
									: colData
								: colData
					}
				}
			})
			// console.log('formattedObj', formattedObj)
			return formattedObj
		})

		setExportData(finalData)
	}

	const handleToggle = (event) => {
		setAnchorEl(anchorEl ? null : event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const id = open ? 'simple-popper' : undefined

	React.useEffect(() => {
		if (Array.isArray(dataToExport)) {
			setExportData(dataToExport)
		} else {
			handleExportTableData()
		}
	}, [JSON.stringify(tableData)])
	return (
		<div>
			<Tooltip title='Download'>
				<IconButton
					aria-describedby={id}
					sx={{
						marginLeft: '1rem'
					}}
					onClick={handleToggle}
				>
					<Icon ascent='textDark' fontSize={26}>
						<SvgIcons.DOWNLOAD_SVG />
					</Icon>
				</IconButton>
			</Tooltip>
			<Popper
				id={id}
				anchorEl={anchorEl}
				open={open}
				role={undefined}
				transition
				disablePortal
				placement='bottom-end'
				sx={{
					zIndex: 999
				}}
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
						}}
					>
						<div>
							<ClickAwayListener onClickAway={handleClose}>
								<Paper elevation={6} component={Box} borderRadius='0.75rem'>
									{/* <Button
                                            // padding=""
                                            borderRadius="0"
                                            ascent="trans"
                                            variant="text"
                                            colorAscent={"textDark"}
                                            display="flex"
                                            textTransform="none"
                                            alignItems="center"
                                            sx={{
                                                display: "flex",
                                                width: "100%",
                                                justifyContent:
                                                    "flex-start",
                                            }}
                                        >
                                            <Box
                                                display="block"
                                                component={"span"}
                                                marginRight="0.75rem"
                                            >
                                                <Icon block fontSize={24}>
                                                    <SvgIcons.DOWNLOAD_SVG />
                                                </Icon>
                                            </Box>
                                            Download all data
                                        </Button> */}
									<CSVLink target='_blank' data={exportData} filename={new Date().toISOString().concat('.csv')}>
										<Button
											// padding=""
											borderRadius='0'
											ascent='trans'
											variant='text'
											display='flex'
											colorAscent={'textDark'}
											alignItems='center'
											sx={{
												display: 'flex',
												width: '100%',
												justifyContent: 'flex-start'
											}}
											textTransform='none'
										>
											<Box display='block' component={'span'} marginRight='0.75rem'>
												<Icon block fontSize={18}>
													<SvgIcons.Export_SVG />
												</Icon>
											</Box>
											Export as .csv
										</Button>
									</CSVLink>
								</Paper>
							</ClickAwayListener>
						</div>
					</Grow>
				)}
			</Popper>
		</div>
	)
})

export default TableMenuButton
